/// React router dom
import { Outlet, Route, Routes } from "react-router-dom";
/// Css
import "./chart.css";
import "./index.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Pages
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import LockScreen from "./pages/LockScreen";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

import ComingSoon from "./pages/ComingSoon";
import Dashboard from "./components/Dashboard";
import Beneficiaries from "./components/Beneficiaries";
import ReportList from "./components/Report/ReportList";
import RequestsList from "./components/Requests/RequestsList";
import TopUpWithdrawList from "./components/TopUpWithdraw/TopUpWithdrawList";
import ApiManagement from "./components/ApiManagement";
import Topup from "./components/Topup";
import CustomerList from "./components/Customers";
import CustomerDetails from "./components/Customers/CustomerDetails";
import TransactionsList from "./components/Transactions";

const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const allroutes = [
    { url: "", component: <Dashboard /> },
    { url: "dashboard", component: <Dashboard /> },
    { url: "api-management", component: <ApiManagement /> },
    { url: "top-up", component: <Topup /> },
    { url: "beneficiaries", component: <Beneficiaries /> },
    { url: "customer", component: <CustomerList /> },
    { url: "customer-details/:id", component: <CustomerDetails /> },
    {
      url: "transaction-activity",
      component: <TransactionsList />,
    },
    { url: "requests", component: <RequestsList /> },
    { url: "report", component: <ReportList /> },
    {
      url: "topup-withdraw",
      component: <TopUpWithdrawList />,
    },
    { url: "notifications", component: <ComingSoon title="Notifications" /> },
    {
      url: "cash-vault-management",
      component: <ComingSoon title="Cash Vault Management" />,
    },
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  return (
    <div id="main-wrapper" className="show">
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Markup;
